<div class="container-fluid h-100">
  <div class="d-flex justify-content-center align-items-center h-100">
    <div class="d-flex flex-column">
      <h2 class="text-center">Error:404</h2>
      <h4 class="text-center">Ops! Algo deu errado. Não conseguimos resolver essa solicitação, entre em contato com o ADM.</h4>
      <a class="text-center" [routerLink]="['/']">Voltar</a>
    </div>
  </div>
</div>
